import { determineNotificationPlugin, PushPluginType } from 'shared/engine-dynamic';
import { FirebaseJsChilduppNotification } from './firebasejs-childupp-notification';
import { PhonegapChilduppNotification } from './phonegap-childupp-notification';
import { FCMChilduppNotification } from "./fcm-childupp-notification";
import { NoneChilduppNotification } from './none-childupp-notification';

/**
 * Build a notification service based on the plugin available
 * @return {IChilduppNotification}
 */
function buildEngineDynamicNotification() {

    switch (determineNotificationPlugin()) {
        case PushPluginType.PhonegapNotification:
            return new PhonegapChilduppNotification();
        case PushPluginType.FCMPlugin:
            return new FCMChilduppNotification();
        case PushPluginType.FirebaseJS:
            return new FirebaseJsChilduppNotification();
        default:
            return new NoneChilduppNotification();
    }
}

/**
 * @type IChilduppNotification
 */
export default buildEngineDynamicNotification();



// WEBPACK FOOTER //
// ./src/shared/childupp-notifications/index.js